import ApiService from './ApiService'

// General lists
export const apiCountriesList = () => ApiService.get('/list/countries')
export const apiStatesList = id => ApiService.get(`/list/states/${id}`)
export const apiImage = data => ApiService.post('/list/image', data)
export const apiImageGet = url => ApiService.blob(url)

// User scoped lists
export const apiListRoles = () => ApiService.get('/user/list/roles')
export const apiListUsers = () => ApiService.get('/user/list/users')
export const apiListCustomers = () => ApiService.get('/user/list/customers')
export const apiListInspectors = () => ApiService.get('/user/list/inspectors')
export const apiListProjects = () => ApiService.get('/user/list/projects')
export const apiListTransformers = id => ApiService.get(`/user/list/transformers${id ? `/${id}` : ''}`)
export const apiListTestTypes = id => ApiService.get(`/user/list/test-types${id ? `/${id}` : ''}`)
export const apiListGlobals = () => ApiService.get('/user/list/globals')
export const apiListCoolingTypes = () => ApiService.get('/user/list/cooling-types')
export const apiListReferenceStandards = () => ApiService.get('/user/list/reference-standards')
export const apiListWindingMaterials = () => ApiService.get('/user/list/winding-materials')
export const apiListEquipments = () => ApiService.get('/user/list/equipments', null, { loader: false })
export const apiListDiagrams = () => ApiService.get('/user/list/diagrams', null, { loader: false })
export const apiListLabSurfaceAreas = () => ApiService.get('/user/list/lab-surface-areas')
export const apiListTransformerTests = id => ApiService.get(`/user/list/transformer-tests${id ? `/${id}` : ''}`)
export const apiListFeedbacks = () => ApiService.get('/user/list/feedbacks')

// Roles & Permissions
export const apiPermissions = () => ApiService.get('/user/permission-datas')
export const apiRolesList = data => ApiService.get('/user/roles', data)
export const apiRolesView = id => ApiService.get(`/user/roles/${id}`)
export const apiRolesForm = (id, data) => ApiService.post(`/user/roles${id ? `/${id}` : ''}`, data)
export const apiRolesStatus = id => ApiService.post(`/user/roles/${id}/status`)

// Users
export const apiUsersList = data => ApiService.get('/user/users', data)
export const apiUsersView = id => ApiService.get(`/user/users/${id}`)
export const apiUsersForm = (id, data) => ApiService.post(`/user/users${id ? `/${id}` : ''}`, data)
export const apiUsersStatus = id => ApiService.post(`/user/users/${id}/status`)
export const apiUsersVerified = id => ApiService.post(`/user/users/${id}/verified`)

// Customers
export const apiCustomersList = data => ApiService.get('/user/customers', data)
export const apiCustomersView = id => ApiService.get(`/user/customers/${id}`)
export const apiCustomersForm = (id, data) => ApiService.post(`/user/customers${id ? `/${id}` : ''}`, data)
export const apiCustomersStatus = id => ApiService.post(`/user/customers/${id}/status`)

// Inspectors
export const apiInspectorsList = data => ApiService.get('/user/inspectors', data)
export const apiInspectorsView = id => ApiService.get(`/user/inspectors/${id}`)
export const apiInspectorsForm = (id, data) => ApiService.post(`/user/inspectors${id ? `/${id}` : ''}`, data)
export const apiInspectorsStatus = id => ApiService.post(`/user/inspectors/${id}/status`)
export const apiInspectorsVerified = id => ApiService.post(`/user/inspectors/${id}/verified`)

// Projects
export const apiProjectsList = data => ApiService.get('/user/projects', data)
export const apiProjectsView = id => ApiService.get(`/user/projects/${id}`)
export const apiProjectsForm = (id, data) => ApiService.post(`/user/projects${id ? `/${id}` : ''}`, data)
export const apiProjectsStatus = id => ApiService.post(`/user/projects/${id}/status`)

// Transformers
export const apiTransformersList = data => ApiService.get('/user/transformers', data)
export const apiTransformersView = id => ApiService.get(`/user/transformers/${id}`)
export const apiTransformersForm = (id, data) => ApiService.post(`/user/transformers${id ? `/${id}` : ''}`, data)
export const apiTransformersStatus = id => ApiService.post(`/user/transformers/${id}/status`)
export const apiTransformersLock = id => ApiService.post(`/user/transformers/${id}/lock`)

// Test Types
export const apiTestTypesList = data => ApiService.get('/user/test-types', data)
export const apiTestTypesView = id => ApiService.get(`/user/test-types/${id}`)
export const apiTestTypesForm = (id, data) => ApiService.post(`/user/test-types${id ? `/${id}` : ''}`, data)
export const apiTestTypesStatus = id => ApiService.post(`/user/test-types/${id}/status`)

// Transformer Tests
export const apiTransformerTestsList = data => ApiService.get('/user/transformer-tests', data)
export const apiTransformerTestsView = (id, data) => ApiService.get(`/user/transformer-tests/${id}`, data)
export const apiTransformerTestsForm = (id, data) => ApiService.post(`/user/transformer-tests${id ? `/${id}` : ''}`, data)
export const apiTransformerTestsClone = id => ApiService.get(`/user/transformer-tests/${id}/clone`)

// Tests
export const apiTestsList = (id, data) => ApiService.get(`/user/transformer-tests${id ? `/${id}` : ''}/trans-tests`, data)
export const apiTestsView = id => ApiService.get(`/user/trans-tests${id ? `/${id}` : ''}`)
export const apiTestsForm = (id, data) => ApiService.post(`/user/trans-tests${id ? `/${id}` : ''}`, data)
export const apiTestsStatus = (id, data) =>
    ApiService.post(`/user/trans-tests/${id}/${data.type === 0 ? 'status' : 'authorised'}`, data)

// Reports
export const apiTransReportsList = (id, data) => ApiService.get(`/user/transformer-tests/${id}/reports`, data)
export const apiTransReportsForm = (id, data) => ApiService.post(`/user/transformer-tests/${id}/reports`, data)
export const apiTransReportsDestroy = (id, data) => ApiService.get(`/user/trans-reports/${id}/destroy`, data)

// Editable Reports
export const apiTransEditableReportsForm = (id, data) => ApiService.post(`/user/transformer-tests/${id}/editable-reports`, data)
export const apiTransEditableReportsDestroy = (id, data) => ApiService.get(`/user/trans-editable-reports/${id}/destroy`, data)

// Feedbacks
export const apiFeedbacksList = data => ApiService.get('/user/feedbacks', data)
export const apiFeedbacksView = id => ApiService.get(`/user/feedbacks/${id}`)
export const apiFeedbacksForm = (id, data) => ApiService.post(`/user/feedbacks${id ? `/${id}` : ''}`, data)
export const apiFeedbacksPDF = id => ApiService.blob(`/user/feedbacks/${id}/pdf`)
export const apiFeedbacksReportsCustomer = data => ApiService.get('/user/feedbacks/reports/customer', data)
export const apiFeedbacksReportsMonthly = data => ApiService.get('/user/feedbacks/reports/monthly', data)
